import { Phone } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const CTASection = ({ onReservar }) => {
  const ref = useScrollAnimation();

  return (
    <section
      id="contact"
      className="relative py-32 md:py-48 overflow-hidden"
      data-testid="cta-section"
      style={{
        backgroundImage: `url('https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1920&q=80')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#0a0a0a]/85" />

      {/* Gold radial glow */}
      <div
        className="absolute inset-0"
        style={{ background: 'radial-gradient(ellipse at center, rgba(212,175,55,0.1) 0%, transparent 65%)' }}
      />

      <div ref={ref} className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 fade-in-up">
        <div className="max-w-2xl mx-auto text-center">
          <span className="text-gold text-xs tracking-[0.4em] uppercase font-body">Reserva tu experiencia</span>
          <div className="h-px w-12 bg-gold mt-3 mb-8 mx-auto" />
          <h2 className="font-heading text-4xl md:text-6xl text-[#ededed] mb-6 leading-tight">
            Reserva tu mesa hoy y disfruta de la{" "}
            <span className="italic text-gold-dark">auténtica cocina casera</span>
          </h2>
          <p className="font-body text-[#a3a3a3] text-lg mb-12 leading-relaxed">
            No esperes más para vivir una experiencia gastronómica cercana y deliciosa. Ven a Restaurante Neli y descubre por qué tantos clientes repiten.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              data-testid="cta-reservar-btn"
              onClick={onReservar}
              className="bg-gold text-black font-bold text-xs tracking-widest uppercase px-10 py-5 rounded-[20px] hover:bg-gold-dark transition-all duration-300 hover:-translate-y-0.5"
            >
              Reservar Mesa Ahora
            </button>
            <a
              href="tel:948595567"
              className="border border-gold text-gold font-bold text-xs tracking-widest uppercase px-10 py-5 rounded-[20px] hover:bg-gold hover:text-black transition-all duration-300 flex items-center gap-3 justify-center"
              data-testid="cta-phone-btn"
            >
              <Phone size={14} />
              948 59 55 67
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
